module.exports = __webpack_public_path__ + "img/gls-cod-alternate.21fc7094.png";